export default "__VITE_ASSET__DxWh9pef__"